import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';

import { BillingStatusEnums } from '@amfam/billing/shared/ui';
import { PolicySelectors } from '@amfam/policy/data-access';
import { Policy, PolicyStatus } from '@amfam/policy/models';
import { fromRouterActions } from '@amfam/shared/utility/navigation';
import { CopyService, EventDispatcherService } from '@amfam/shared/utility/shared-services';

import {
  AccountForSimplifiedPayment,
  OneTimePayActions,
  OneTimePayFeatureFacade,
  OneTimePaySelectors,
  OneTimePaySetup
} from '../../..';

@Component({
  selector: 'amfam-phoenix-payment-confirmation-wrapper',
  templateUrl: './phoenix-payment-confirmation-wrapper.component.html',
  styleUrls: ['./phoenix-payment-confirmation-wrapper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class PhoenixPaymentConfirmationWrapperComponent implements OnInit, OnDestroy {
  billAccountOptions$: Observable<AccountForSimplifiedPayment[]>;
  billAccountOptionFiltered: AccountForSimplifiedPayment[];
  data: OneTimePaySetup;
  primaryButtonName: string;
  secondaryButtonName: string;
  showAutopayButton = true;
  amountSubheading: string;
  private policy: Policy;
  private policy$ = this.store.select(PolicySelectors.selectSelectedPolicy);
  private stop$: Subject<void> = new Subject<void>();

  constructor(
    private store: Store,
    private copyService: CopyService,
    private oneTimePayFacade: OneTimePayFeatureFacade,
    private eventDispatcherService: EventDispatcherService
  ) {
    this.store
      .select(OneTimePaySelectors.selectOneTimePayState)
      .pipe(take(1))
      .subscribe(data => {
        Object.keys(data.entities).forEach(key => {
          this.data = data.entities[key];
        });
      });

    this.policy$.pipe(takeUntil(this.stop$)).subscribe(policy => {
      this.policy = policy;
    });
  }

  ngOnInit(): void {
    this.billAccountOptions$ =
      this.oneTimePayFacade.getSimplifiedPaymentBillAccountsWithAlertMessageList();
    this.billAccountOptions$.subscribe(
      billAccountOptions =>
        (this.billAccountOptionFiltered = billAccountOptions.filter(ba => ba.isSelected))
    );
    this.primaryButtonName = this.copyService.getCopy('billing.phoenixPayment.setupAutopay');
    this.secondaryButtonName = this.copyService.getCopy('shared.cancel');
    this.amountSubheading = this.copyService.getCopy('billing.phoenixPayment.amountSubheading');

    if (
      this.billAccountOptionFiltered[0].pillStatus.statusText === BillingStatusEnums.ESCROW ||
      this.policy.policyStatus === PolicyStatus.Cancelled ||
      this.policy.policyStatus === PolicyStatus.Expired ||
      this.policy.policyStatus === PolicyStatus.PendingCancel
    )
      this.showAutopayButton = false;
  }

  cancel() {
    this.store.dispatch(OneTimePayActions.goToCancelPath());
  }

  gotoAutopay() {
    // This should redirect to the new autopay page for phoenix policies?
    this.store.dispatch(
      fromRouterActions.Go({
        path: ['/overview']
      })
    );
  }

  ngOnDestroy() {
    this.stop$.next();
    this.stop$.complete();
  }
}
